export default "/images/vendor/flag-icon-css/flags/4x3/mz.svg?dac5f7ee4f2a02e79de217bea9f79849";